import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './FormFieldError.module.scss.js';

var _excluded = ["className", "name", "meta"];
var FormFieldError = function FormFieldError(_ref) {
  var _cx;
  var className = _ref.className;
    _ref.name;
    var _ref$meta = _ref.meta,
    modified = _ref$meta.modified,
    touched = _ref$meta.touched,
    error = _ref$meta.error,
    dirtySinceLastSubmit = _ref$meta.dirtySinceLastSubmit,
    submitError = _ref$meta.submitError,
    submitting = _ref$meta.submitting,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (error || submitError && !dirtySinceLastSubmit && !submitting) && (modified || touched) && /*#__PURE__*/React.createElement("div", _extends({
    className: cx(style.description, (_cx = {}, _cx[style.error] = error || submitError, _cx), className)
  }, props), (error || submitError) && /*#__PURE__*/React.createElement("span", null, error || submitError)));
};
FormFieldError.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  meta: PropTypes.shape({
    dirtySinceLastSubmit: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    submitError: PropTypes.string,
    submitting: PropTypes.bool,
    modified: PropTypes.bool,
    touched: PropTypes.bool
  }).isRequired
};

export { FormFieldError as default };
//# sourceMappingURL=index.js.map
